<app-main-layout>
  <app-client-view-page></app-client-view-page>
</app-main-layout>
